.nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title {
  font-size: 24px;
}

/* Only the first letter: Italian writes "mer 7 ottobre" in lower case, and
 * capitalising every word would be wrong in it. */
.title::first-letter {
  text-transform: uppercase;
}

/* The phone's day line: full width, title centred between the edges. */
.phone .title {
  flex: 1 1 auto;
  text-align: center;
}

@media (min-width: 720px) {
  .phone {
    display: none;
  }
}

@media (max-width: 719px) {
  .desktop {
    display: none;
  }
}

.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-control);
  background: none;
  color: var(--ink);
  cursor: pointer;
}

.arrow:disabled {
  color: var(--line);
  cursor: default;
}

/* The blueprint draws the arrows as bare chevrons in a 44px target (#92).
 * They are masks painted in currentColor, so a disabled one fades too. */
.previous,
.next {
  width: 24px;
  height: 24px;
  background-color: currentColor;
}

.previous {
  -webkit-mask: url('./previous.svg') no-repeat center / contain;
  mask: url('./previous.svg') no-repeat center / contain;
}

.next {
  -webkit-mask: url('./next.svg') no-repeat center / contain;
  mask: url('./next.svg') no-repeat center / contain;
}
